import * as types from './types';
import _ from 'lodash';
import moment from 'moment';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { PreviewProcessOrderEnum } from 'Common/FieldEnum';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

const INITIAL_STATE = {
  submitError: null,
  processLoading: false,
  createLoading: false,
  processedOrderData: [],
  processId: '',
  previewOrderLoading: false,
  previewOrderError: null,
  printLoading: false,
  printError: null,
  printVendorData: null,
  printPreview: null,
  processMessageError: null,
  processDuplicateIds: [],
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.PROCESS_ORDER_ERROR:
      const processOrderErrorResponse = action.payload.response;
      if (
        _.has(processOrderErrorResponse, 'data.Errors') &&
        processOrderErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          submitError: processOrderErrorResponse.data.Errors,
        };
      }
      return {
        ...state,
        submitError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while processing Order(s). Please try again',
        },
      };
    case types.PROCESS_ORDER_LOADING:
      return {
        ...state,
        processLoading: action.payload,
      };

    case types.PROCESSED_ORDER_PREVIEW_DATA:
      action.payload && action.payload.PreviewData
        ? (action.payload.PreviewData = action.payload.PreviewData.map(
            item => ({
              ...item,
              [PreviewProcessOrderEnum.DeliveryDT]: [
                PreviewProcessOrderEnum.DeliveryDT,
              ]
                ? moment(item[PreviewProcessOrderEnum.DeliveryDT]).format(
                    DATE_FORMAT_FOR_UI
                  )
                : '',
              [PreviewProcessOrderEnum.Cost]: Number(
                item[PreviewProcessOrderEnum.Cost]
              ).toFixed(4),
            })
          ))
        : (action.payload.PreviewData = []);

      return {
        ...state,
        processedOrderData: action.payload,
      };
    case types.CREATE_PO_WO_BO_LOADING:
      return {
        ...state,
        createLoading: action.payload,
      };
    case types.SET_PROCESS_ID:
      return {
        ...state,
        processId: action.payload,
      };
    case types.FETCH_PREVIEW_ORDER_LOADING:
      return {
        ...state,
        previewOrderLoading: action.payload,
      };
    case types.FETCH_PREVIEW_ORDER_ERROR:
      const previewErrorResponse = action.payload.response;
      if (
        _.has(previewErrorResponse, 'data.Errors') &&
        previewErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          previewOrderError: previewErrorResponse.data.Errors,
        };
      }
      return {
        ...state,
        previewOrderError: {
          Title: TitleEnum.Error,
          Message: 'An error occurred while saving Order. Please try again',
        },
      };
    case types.CLEAR_PREVIEW_ORDER_ERROR:
      return {
        ...state,
        previewOrderError: null,
        submitError: null,
        printError: null,
      };

    case types.PRINT_PREVIEW_LOADING:
    case types.PRINT_VENDOR_SUMMARY_LOADING:
      return {
        ...state,
        printLoading: action.payload,
      };

    case types.PRINT_PREVIEW_ERROR:
    case types.PRINT_VENDOR_SUMMARY_ERROR:
      const printVendorErrorResponse = action.payload.response;
      if (
        _.has(printVendorErrorResponse, 'data.Errors') &&
        printVendorErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          printError: printVendorErrorResponse.data.Errors,
        };
      }
      return {
        ...state,
        printError: {
          Title: TitleEnum.Error,
          Message: 'An error occurred while creating PDF. Please try again',
        },
      };
    case types.PRINT_VENDOR_SUMMARY_DATA:
      return {
        ...state,
        printVendorData: action.payload,
      };
    case types.CLEAR_PRINT_VENDOR_SUMMARY_DATA:
      return {
        ...state,
        printVendorData: null,
      };
    case types.PRINT_PREVIEW_DATA:
      return {
        ...state,
        printPreviewData: action.payload,
      };
    case types.CLEAR_PRINT_PREVIEW_DATA:
      return {
        ...state,
        printPreviewData: null,
      };
    case types.SET_PROCESS_MESSAGE_ERROR:
      return {
        ...state,
        processMessageError: action.payload.message,
        processDuplicateIds: action.payload.duplicateIds,
      };
    case types.CLEAR_PROCESS_MESSAGE:
      return {
        ...state,
        processMessageError: null,
        processDuplicateIds: []
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/state/processOrder/reducer.js